import { Button, ButtonVariant } from '@aus-platform/design-system';
import classNames from 'classnames';
import React, { useState } from 'react';

// Types.
type ExpandableTextProps = {
  text: string;
  maxWords?: number;
  className?: string;
  expandText?: string;
  collapseText?: string;
};

export const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  maxWords = 30,
  className = '',
  expandText = 'view more',
  collapseText = 'view less',
}) => {
  // States.
  const [isExpanded, setIsExpanded] = useState(false);

  // Variables.
  const trimmedText = text.trim();

  const words = trimmedText.split(/\s+/);

  const isOverflowing = words.length > maxWords;

  const truncatedText = isOverflowing
    ? words.slice(0, maxWords).join(' ')
    : trimmedText;

  const displayText = isExpanded ? trimmedText : truncatedText;

  const toggleLabel = isExpanded ? collapseText : expandText;

  // Handlers.
  const handleToggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  if (!trimmedText) {
    return null;
  }

  return (
    <div className={classNames('expandable-text', className)}>
      <p className="expandable-text__content">
        <span>{displayText}</span>

        {isOverflowing && (
          <>
            {!isExpanded && <span>...</span>}
            &nbsp;
            <Button
              variant={ButtonVariant.Link}
              className="expandable-text__toggle"
              onClick={handleToggleExpand}
            >
              {toggleLabel}
            </Button>
          </>
        )}
      </p>
    </div>
  );
};
